import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  VStack,
  Textarea,
  useToast,
  Select,
  Spinner,
} from '@chakra-ui/react';
import axios from 'axios';
import { FaCopy } from 'react-icons/fa';
import { BsFillQuestionSquareFill } from 'react-icons/bs';
import './Journey.css';
import { indexof } from 'stylis';
import DNSrecords from './DNSrecords';
function Journey() {
  const toast = useToast();
  const [domainData, setDomainData] = useState(null);
  const [domainName, setDomainName] = useState();
  const [selectedValue, setselectedValue] = useState('1');
  const [loading, setLoading] = useState(false);
  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    try {
      const response = await axios.post(
        'https://bounce.mailamp.in/mailgun/create/domain',
        {
          name: domainName,
          option: selectedValue,
        },
      );
      setDomainData(response.data.data);
      console.log('Response:', response.data); // You can log the response to see the server's reply
    } catch (error) {
      console.error('Error:', error); // Log any error that occurs during the request
    } finally {
      setLoading(false);
    }
  };
  const handleDomainNameChange = (event) => {
    setDomainName(event.target.value);
  };
  const handleChange = (event) => {
    if (event.target.value === 'USA') {
      setselectedValue('1');
    }
    if (event.target.value === 'EURO') {
      setselectedValue('2');
    }
  };
  const handleClick = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
    } catch (error) {
      console.log(error.message);
    }
  };
  return (
    <>
      <Box
        p={5}
        mt={90}
        shadow="md"
        borderWidth="1px"
        borderRadius="md"
        maxWidth="500px"
        mx="auto"
        bg="white"
      >
        <form onSubmit={handleSubmit}>
          <VStack spacing={4}>
            <FormControl id="sending-domain" isRequired>
              <FormLabel>Sending Domain</FormLabel>
              <Input
                type="text"
                placeholder="Enter sending domain"
                onChange={handleDomainNameChange}
              />
            </FormControl>
            <FormControl id="country" isRequired>
              <FormLabel>Select Country</FormLabel>
              <Select placeholder="Select country" onChange={handleChange}>
                <option value="USA">USA</option>
                <option value="EURO">EURO</option>
              </Select>
            </FormControl>

            <FormControl id="sending-domain-mail" isRequired>
              <FormLabel>Sending Domain Mail</FormLabel>
              <Input type="email" placeholder="Enter sending domain mail" />
            </FormControl>

            <FormControl id="company-name" isRequired>
              <FormLabel>Company Name</FormLabel>
              <Input type="text" placeholder="Enter company name" />
            </FormControl>

            <FormControl id="company-website" isRequired>
              <FormLabel>Company Website</FormLabel>
              <Input type="url" placeholder="Enter company website" />
            </FormControl>

            <FormControl id="privacy-policy" isRequired>
              <FormLabel>Company Privacy Policy URL</FormLabel>
              <Input type="url" placeholder="Enter privacy policy URL" />
            </FormControl>

            <FormControl id="company-address" isRequired>
              <FormLabel>Company Address</FormLabel>
              <Textarea placeholder="Enter company address" />
            </FormControl>

            <Button
              type="submit"
              variant="brand"
              width="full"
              isLoading={loading}
              isDisabled={loading}
            >
              {loading ? <Spinner size="sm" /> : 'Submit'}
            </Button>
          </VStack>
        </form>
      </Box>
      {domainData && <DNSrecords domainData={domainData} />}
    </>
  );
}

export default Journey;
